import React from "react"
import { Spinner } from "@shopify/polaris"

/**
 * Shown while a route-level lazy chunk is loading (React.Suspense fallback).
 */
export default function RouteChunkFallback() {
	return (
		<div
			style={{
				padding: "2rem",
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				minHeight: "240px",
			}}
		>
			<Spinner size="large" accessibilityLabel="Loading page" />
		</div>
	)
}
